var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('main',{staticClass:"creator-feed"},[(_vm.$user)?_c('section',[_c('HomeFeed',{attrs:{"postview":true}})],1):_c('section',[_c('HomePublic')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }